module.exports = __webpack_public_path__ + "static/media/Prm-OM2.69b3d4df.jpg";